import {defaultOptionsSetting} from "./helpers/select";

$(document).ready(function () {
    $('.modal-dialog').draggable({
        handle: ".modal-header"

    });
    $('.show-lock-modal').on('click', function (){
        doAjax('/user-active-routes/get-locks',{}, 'GET').then(response => {
            $('#lock-list-body').html("")
            var html = '';
               response.forEach(function (item){
                   html += '<tr class="row-show row-one-line" style="font-size: 13px !important">'+
                       '<td style="width: 160px"> ' + item.lock_maker+'</td>'+
                       '<td style="width: 160px"> ' + item.name+'</td>'+
                       '<td style="word-break: break-word">' + item.details+'</td>'+
                       '<td style="word-break: break-word">' + item.parent+'</td>';
                   if(item.show_destroy){
                       html += '<td>'+ '<a class="destroy-lock" data-destroy="'+item.destroy_url+'"> <i class="fa fa-trash"></i> </a>'+'</td>'+'</tr>'
                       $('.destroy-lock').on('click', function (){
                       });
                   }
                   else{
                       html += '<td></td></tr>'
                   }
               });

            $('#lock-list-body').html(html)
            $('.row-show').each(function (index) {
                if ((index + 1) % 2 === 0) {
                    this.classList.add('row-even');
                } else {
                    this.classList.add('row-odd');
                }
            });
            $('.destroy-lock').on('click', function (){
               doAjax($(this).data('destroy')).then(response=>{
                   $(this).parent().parent().remove()
               })
            });
            $('#locks-modal').modal('show');
        });

    })

    if($('#make-lock-request').val() == 1){
        makeLockRequest();
        setInterval(function() {
            makeLockRequest();
        }, 30 * 1000); // 60 * 1000 milsec
    }
    if($('#refresh-alerts').val() == 1){
        setInterval(function() {
            getAlertsCountAndRefreshData();
        }, 30000)
    }

    if($('#queue-tasks-poll').val() == 1){
        pollQueueTasks(); // od razu po wejsciu na strone, bez czekania na tick
        setInterval(function() {
            pollQueueTasks();
        }, 10000)
    }

    $('.btn-cancel-edit-with-lock').on('click', function (){
        doAjax('/user-active-routes/destroy-temp-lock', {route:$('#current-route-to-lock').val(), url:$('#current-url-to-lock').val()} ).then(()=>{
            window.location.href = $(this).data("href")
        })
    })
    const sidebar_type = $('body').data('sidebar-type');
    if (sidebar_type == 'manual') {
        let sidebarState = getCookie('sidebarToggleState') == 'opened' ? 'closed' : 'opened';
        if(sidebarState == 'closed' || getCookie('sidebarToggleState') == ''){
            $("body").addClass("mini-navbar");
        }
        else{
            $("body").removeClass("mini-navbar");
        }
    }
    $('.icon-delete').click(function (event) {
        handleIconDeleteClick(event);
    });

    $('.delete-multi').click(function (event) {
        let form = $('#bulk-action');
        event.preventDefault();
        let action_type = $(this).data('action');
        form.find('input[name="action_type"]').val(action_type);
        swal({
            title: "Usunąć wybrane elementy?",
            text: "Danych nie będzie się dało odzyskać!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Usuń",
            cancelButtonText: "Anuluj",
            closeOnConfirm: true,
        }, function () {
            form.submit();
        });
    });

// show filters if results were filtered
    if ($('#main-table').data('filtered') === true || $('#main-table').data('filtered') == 1) {
        const urlParams = new URLSearchParams(window.location.search);
         if(!urlParams.has('hide_filter_box')){
             $('.filters').toggle(true);
         }
    } else {
        $('.filters').toggle(false);
    }

// control both pagination forms to have same behaviour
    $('.per-page').change(function () {
        const linked_class = $(this).data('linked');
        $('.' + linked_class).val(this.value);
        $('#' + $(this).attr('form')).submit();
    });

    (function () {
        const originalAddClassMethod = jQuery.fn.addClass;
        const originalRemoveClassMethod = jQuery.fn.removeClass;

        jQuery.fn.addClass = function () {
            var result = originalAddClassMethod.apply(this, arguments);
            jQuery(this).trigger('cssClassChanged');
            return result;
        };
        jQuery.fn.removeClass = function () {
            var result = originalRemoveClassMethod.apply(this, arguments);
            jQuery(this).trigger('cssClassChanged');
            return result;
        };
    })();

    function createCookie(cookieName, cookieValue, daysToExpire) {
        const date = new Date();
        date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
        document.cookie = cookieName + "=" + cookieValue + "; path=/ ;expires=" + date.toGMTString();
    }

    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    $('body').on('cssClassChanged', function () {
        // w trybie "upper" nie ma klasy mini-navbar - widocznoscia panelu steruje
        // upper-menu-open, a li.sub-menu przelacza handler przyciskow menu gornego
        if (sidebar_type == 'upper') return;

        const submenu = $('.navbar-header button.btn-selected').data('submenu');
        const selector = '#side-menu li.sub-menu[data-submenu="' + submenu + '"]';
        const mini_navbar = $('body').hasClass('mini-navbar');

        if (mini_navbar) $("#side-menu li.sub-menu").hide();
        else $(selector).show();
    });

    // Tryb "upper" (Ustawienia profilu -> menu szczegolowe "Gorne"): menu boczne jest ukryte,
    // a jego zawartosc pokazujemy jako plywajacy panel pod kliknietym przyciskiem menu gornego.
    // Uzywamy tego samego wezla DOM co menu boczne, wiec uprawnienia (hasAccess), skorki
    // i podswietlenie biezacej pozycji dzialaja bez duplikowania markupu.
    const UPPER_MENU_OPEN_CLASS = 'upper-menu-open';
    let upperMenuSubmenu = null;

    // pozycja, w ktorej jest otwarte biezace okno - setSubmenu() z inspinia.js oznacza ja
    // klasa active przy ladowaniu strony (inspinia.js laduje sie przed app.js); zapamietujemy
    // ja teraz, bo metisMenu przestawia active przy kazdym rozwinieciu/zwinieciu
    const upperMenuCurrentItems = $('#side-menu li.sub-menu.active').filter(function () {
        return $(this).children('ul.nav-second-level').length > 0;
    });

    function closeUpperMenu() {
        upperMenuSubmenu = null;
        $('.navbar-static-side').removeClass(UPPER_MENU_OPEN_CLASS);
    }

    function openUpperMenu(button, submenu) {
        // podpozycje rozwija/zwija klikniecie (metisMenu, jak w menu bocznym); przy kazdym
        // otwarciu panelu startujemy od stanu: zwiniete wszystko poza pozycja biezacego okna.
        // active zdejmujemy razem z in - metisMenu po active decyduje, czy klik rozwija czy zwija
        $('#side-menu li.sub-menu').removeClass('active')
            .children('ul.nav-second-level').removeClass('in').attr('aria-expanded', false);
        upperMenuCurrentItems.addClass('active')
            .children('ul.nav-second-level').addClass('in').attr('aria-expanded', true);

        // lewy-gorny rog panelu ma lezec pod lewym-dolnym rogiem przycisku;
        // position: fixed, bo gorna belka to navbar-fixed-top
        const rect = button.getBoundingClientRect();
        upperMenuSubmenu = submenu;
        $('.navbar-static-side')
            // po rozwinieciu podpozycji panel moze wyjsc poza ekran - wtedy przewijamy go (contsup.css)
            .css({left: rect.left + 'px', top: rect.bottom + 'px', maxHeight: (window.innerHeight - rect.bottom) + 'px'})
            .addClass(UPPER_MENU_OPEN_CLASS);
    }

    $('.top-button').on('click', function (event) {
        $('.top-button').removeClass('btn-selected');
        $(event.target).addClass('btn-selected');
        const submenu = event.target.dataset.submenu;
        localStorage.submenu = submenu; // hide or show submenus

        $('.sub-menu').each(function () {
            if (this.dataset.submenu === submenu) {
                $(this).show();
            } else {
                $(this).hide();
            }
        }); // show side panel

        if (sidebar_type == 'upper') {
            // panel znika po kliknieciu gdziekolwiek (handler na document) - ten klik nie moze
            // tam dotrzec, inaczej panel zamykalby sie natychmiast po otwarciu
            event.stopPropagation();

            const isOpen = $('.navbar-static-side').hasClass(UPPER_MENU_OPEN_CLASS);
            if (!submenu || (isOpen && upperMenuSubmenu === submenu)) {
                // ponowne klikniecie w ten sam przycisk zamyka panel;
                // przycisk bez data-submenu (np. wylaczony Kontroling) nie otwiera pustego panelu
                closeUpperMenu();
            } else {
                openUpperMenu(this, submenu);
            }

            return;
        }

        $("body").removeClass("mini-navbar");
        SmoothlyMenu(); // remove mouseover event and reattach id on mouse leave

        if (sidebar_type == 'auto') {
            var navbar = $('.navbar-static-side');
            navbar.off('mouseenter');
            navbar.on('mouseleave', function () {
                $('.navbar-static-side').on('mouseenter', function (event) {
                    event.preventDefault();
                    $("body").removeClass("mini-navbar");
                    SmoothlyMenu();
                });
            });
        }

    });

    if (sidebar_type == 'manual') {
        $('body').on('click', '.side-menu-toggle', function () {
            const mini_class = 'mini-navbar';
            const mini_navbar = $('body').hasClass(mini_class);
            if (mini_navbar) $('body').removeClass(mini_class);
            else $('body').addClass(mini_class);

            const sidebarToggleState = mini_navbar ? 'closed' : 'opened';
            createCookie('sidebarToggleState', sidebarToggleState, {expires: 365});

            SmoothlyMenu();
            window.dispatchEvent(new Event('resize'));
        });
    } else if (sidebar_type == 'upper') {
        // menu boczne jest ukryte przez CSS (contsup.css: body[data-sidebar-type="upper"]);
        // zadnych hoverow na .navbar-static-side ani przelaczania mini-navbar
        $('body').removeClass('mini-navbar');

        // znika po kliknieciu poza panelem; klik w panelu albo rozwija/zwija pozycje (metisMenu),
        // albo jest linkiem, ktory i tak przeladowuje strone
        $(document).on('click', function (event) {
            if ($(event.target).closest('.navbar-static-side').length) return;
            if ($('.navbar-static-side').hasClass(UPPER_MENU_OPEN_CLASS)) closeUpperMenu();
        });
    } else {
        $('body').addClass('mini-navbar');
        SmoothlyMenu();

        $('.navbar-static-side').on('mouseleave', function (event) {
            event.preventDefault();
            $("body").addClass("mini-navbar");
            SmoothlyMenu();

        });

        $('.navbar-static-side').on('mouseenter', function (event) {
            event.preventDefault();
            $("body").removeClass("mini-navbar");
            SmoothlyMenu();
        });
    }


    function prepareMenu() {
        let submenu = 'records';

        if (localStorage.getItem("submenu") != null) {
            submenu = localStorage.submenu;
        }

        let location = window.location.pathname.split('/')[1];
        let fullLocation  = window.location.pathname.split('/').slice(1,3).join('-');
        let avaliable_locations = ['records', 'summaries', 'analysis', 'forecasts', 'admin', 'superadmin', 'company', 'customer-service'];
        if (location !== "" && avaliable_locations.includes(location)) submenu = location;
        if(fullLocation == 'records-dispositions'){
            submenu = 'summaries'
        }
        if(fullLocation == 'communication-message'){
            if(window.location.pathname.split('/').slice(1,4).join('-') == 'communication-message-client_communication'){
                submenu = 'admin'
            }
            else{
                submenu = 'customer-service'
            }
        }
        if(fullLocation == 'choose-promotion' || fullLocation == 'choose-offer' || fullLocation== 'application-settings-order-summary' || fullLocation == 'application-settings-cs-points'){
            submenu = 'admin'
        }
        if(fullLocation == 'superadmin-alert-setting'){
            submenu = 'admin'
        }
        if(fullLocation == 'records-incorrect-payments' || fullLocation == 'records-currency-exchanges'){
            submenu = 'summaries'
        }
        if(fullLocation == 'superadmin-transactions' || fullLocation=='superadmin-sa-orders' ||fullLocation =='superadmin-cs-points'){
            submenu = 'customer-service';
        }
        $('.top-button').removeClass('btn-primary').each(function () {
            if (this.dataset.submenu == submenu) this.classList.add('btn-selected');
        });

        $('.sub-menu').each(function () {
            if (this.dataset.submenu === submenu) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }

    prepareMenu();

// check/uncheck bulk action checkboxes
    $('#check-all').click(function () {
        let checkboxes = $('.check-bulk');
        if (checkboxes.length > 1000) {
            $(this).prop('checked', false);
            toastr.warning($.i18n._('cannot_pick_more_than_1000_rows'), $.i18n._('warning_!'));
        } else {
            if (this.checked) {
                $(checkboxes).prop('checked', true);
            } else {
                $(checkboxes).prop('checked', false);
            }
            updateButton();
        }
    });

    // delegacja: wiersze list moga byc podmieniane dynamicznie (np. odswiezanie wierszy listy dokumentow)
    $(document).on('click', '.check-bulk', function () {
        $('#check-all').prop('checked', false);
    });

    function updateButton() {

        if ($('.check-bulk').is(':checked') && canRemove()) {
            $('.delete-multi').prop('disabled', false);
            $('.delete-multi-prevalidation').prop('disabled', false);
        } else {
            $('.delete-multi').prop('disabled', true);
            $('.delete-multi-prevalidation').prop('disabled', true);
        }
    }

    function canRemove() {
        let value = true;
        $('.check-bulk').each(function () {
            if ($(this).prop("checked") && $(this).hasClass("unremovable")) {
                value = false;
            }
        });
        return value;
    }

    $(document).on('change', '.check-bulk', function () {
        updateButton();
        updateExportBtn();
    });

    function updateEpxortBtnForAllUnchecked() {
        $('.check-bulk').each(function () {
            if ($(this).hasClass("unexportable")) {
                $('.bulk-export-btn').prop("disabled", true);
                return false;
            } else {
                $('.bulk-export-btn').prop("disabled", false);
            }
        });
    }

    function updateExportBtn() {
        let uncheckedAll = true;
        let unexportable = false;
        $('.check-bulk').each(function () {
            if ($(this).prop("checked")) {
                uncheckedAll = false;
            }
            if ($(this).prop("checked") && $(this).hasClass("unexportable")) {
                unexportable = true;
            }
        });
        if (unexportable) {
            $('.bulk-export-btn').prop("disabled", true);
        } else {
            $('.bulk-export-btn').prop("disabled", false);
        }
        if (uncheckedAll) {
            updateEpxortBtnForAllUnchecked();
        }
    }

    // updateEpxortBtnForAllUnchecked();
// update all pagination input with the same value
    $('.page-input').change(function () {
        $('.page-input').val(this.value);
    });

    $('.row-show').each(function (index) {
        if ((index + 1) % 2 === 0) {
            this.classList.add('row-even');
        } else {
            this.classList.add('row-odd');
        }
    });

    $('.s2').select2({
        width: 'resolve',
        language: {
            noResults: function() {
                return $.i18n._('no_positions'); // Twój komunikat
            }
        }
    });

    $('.s2-options').select2(defaultOptionsSetting);
    $('input[name="tag_action"]').on('change', function (){
        $('.tag-section').fadeOut(100)
        let section = $(this).data('section');
        $(section).fadeIn(300)
    })
});
